module.exports = __webpack_public_path__ + "static/media/secao1.22e7388c.png";